import _ from 'lodash'
import { handleActions, createActions } from 'redux-actions'
import { CHANGE_YEAR, SELECT_TOPIC } from './modules/timeline'
import { UPDATE_VIEWPORT } from './modules/map'
import { SHOW_COMPANY_PROFILE, HIDE_COMPANY_PROFILE } from './modules/companies'

const initialState = {
  latestInteraction: null,
  pressedStartAt: null,
}

// Actions
export const ACTIVATE = 'ACTIVATE'
export const DEACTIVATE = 'DEACTIVATE'
export const LEGEND_TOGGLE = 'LEGEND_TOGGLE'

// Create action map
const storeDate = state => ({
  ...state,
  // Only track interaction after the user pressed the inital start button.
  // This prevents that a viewport change event on startup activates the system's
  // active mode.
  latestInteraction: state.pressedStartAt ? Date.now() : null,
})

// TODO: (3) Track interaction inside OF company profile (images, slides)
const actions = [
  CHANGE_YEAR,
  SELECT_TOPIC,
  UPDATE_VIEWPORT,
  SHOW_COMPANY_PROFILE,
  HIDE_COMPANY_PROFILE,
  LEGEND_TOGGLE,
]
const map = _.mapValues(_.keyBy(actions), () => storeDate)

// Reducer
const reducer = handleActions(
  {
    ...map,
    [ACTIVATE]: state => ({
      ...storeDate({ ...state, pressedStartAt: Date.now() }),
    }),
    [DEACTIVATE]: state => ({
      ...state,
      latestInteraction: null,
    }),
  },
  initialState
)

// Action creator
export const { activate, deactivate, legendToggle } = createActions(
  ACTIVATE,
  DEACTIVATE,
  LEGEND_TOGGLE
)

export default reducer
